import React from 'react';
import { Row, Col, Typography } from 'antd';
import { Link } from 'react-router-dom';
import LandingNavbar from './Navbar';
import LandingFooter from './Footer';

const { Text } = Typography;

const LegalPageLayout = ({ title, updated, sections = [], children }) => {
    const scrollTo = (id) => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <div style={{ fontFamily: 'Calibri, sans-serif', minHeight: '100vh', background: '#F8FAFC' }}>
            <LandingNavbar />

            {/* Hero */}
            <div style={{
                background: 'linear-gradient(135deg, #6A0572 0%, #AD1457 60%, #D81B60 100%)',
                padding: '100px 24px 56px',
                position: 'relative',
                overflow: 'hidden',
            }}>
                <div style={{ position: 'absolute', top: '-80px', right: '-80px', width: '320px', height: '320px', borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }} />
                <div style={{ position: 'absolute', bottom: '-50px', left: '-50px', width: '220px', height: '220px', borderRadius: '50%', background: 'rgba(255,255,255,0.04)' }} />

                <div style={{ maxWidth: '1100px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginBottom: '16px' }}>
                        <Link to="/" style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.83rem', textDecoration: 'none' }}>Home</Link>
                        <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.83rem' }}>/</span>
                        <span style={{ color: 'rgba(255,255,255,0.9)', fontSize: '0.83rem' }}>Legal</span>
                        <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.83rem' }}>/</span>
                        <span style={{ color: 'white', fontSize: '0.83rem', fontWeight: '600' }}>{title}</span>
                    </div>

                    <h1 style={{
                        color: 'white', fontSize: '2.2rem', fontWeight: '800',
                        lineHeight: 1.2, margin: '0 0 10px',
                        fontFamily: 'Calibri, sans-serif',
                    }}>
                        {title}
                    </h1>
                    <Text style={{ color: 'rgba(255,255,255,0.65)', fontSize: '0.88rem' }}>
                        Hirehike Technologies Private Limited &nbsp;·&nbsp; Last updated: {updated}
                    </Text>
                </div>
            </div>

            {/* Body */}
            <div style={{ maxWidth: '1100px', margin: '0 auto', padding: '48px 24px 80px' }}>
                <Row gutter={[40, 32]}>

                    {/* Sidebar — table of contents */}
                    <Col xs={24} md={7} lg={6}>
                        <div style={{ position: 'sticky', top: '80px' }}>
                            {sections.length > 0 && (
                                <div style={{
                                    background: 'white', borderRadius: '14px',
                                    boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
                                    overflow: 'hidden',
                                }}>
                                    <div style={{
                                        padding: '14px 20px',
                                        borderBottom: '1px solid #F1F5F9',
                                        background: 'linear-gradient(135deg, rgba(173,20,87,0.05), rgba(216,27,96,0.03))',
                                    }}>
                                        <Text style={{ color: '#AD1457', fontWeight: '700', fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.7px' }}>
                                            On this page
                                        </Text>
                                    </div>
                                    {sections.map((s, i) => (
                                        <button
                                            key={s.id}
                                            onClick={() => scrollTo(s.id)}
                                            style={{
                                                display: 'block', width: '100%', textAlign: 'left',
                                                padding: '11px 20px',
                                                background: 'none', border: 'none', cursor: 'pointer',
                                                color: '#475569', fontSize: '0.88rem', fontWeight: '500',
                                                fontFamily: 'Calibri, sans-serif',
                                                borderBottom: i < sections.length - 1 ? '1px solid #F8FAFC' : 'none',
                                                transition: 'color 0.2s',
                                            }}
                                            onMouseEnter={e => { e.currentTarget.style.color = '#AD1457'; e.currentTarget.style.background = 'rgba(173,20,87,0.04)'; }}
                                            onMouseLeave={e => { e.currentTarget.style.color = '#475569'; e.currentTarget.style.background = 'none'; }}
                                        >
                                            {s.label}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </Col>

                    {/* Content */}
                    <Col xs={24} md={17} lg={18}>
                        <div style={{
                            background: 'white',
                            borderRadius: '16px',
                            boxShadow: '0 2px 16px rgba(0,0,0,0.06)',
                            padding: '40px',
                        }}>
                            {children}
                        </div>
                    </Col>

                </Row>
            </div>

            <LandingFooter />
        </div>
    );
};

export default LegalPageLayout;
